import { useSelector } from "react-redux";

import { TAppState } from "store/root.store";

export const useTrustbenSelector = () => {
  return useSelector((state: TAppState) => state.trustbenReducer);
};
